import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SimpleLeftArrowIcon = createIcon({
  displayName: 'SimpleLeftArrow',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M14,8l-4,4l4,4"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      ></path>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const SimpleLeftArrow: FC<IconProps> = (props) => {
  return <CustomIcon as={SimpleLeftArrowIcon} {...props} />
}

export default memo(SimpleLeftArrow)
